/* Keep the product scene beneath the real header without a scroll listener. */
(()=>{
  let observer;
  const init=()=>{
    observer?.disconnect();
    const main=document.getElementById('MainContent');
    const root=main?.querySelector('[data-sb-world]');
    if(!root)return;
    const header=document.getElementById('header-component');
    const update=()=>main.style.setProperty('--sbx-sticky-top',`${Math.ceil(header?.getBoundingClientRect().height||0)}px`);
    update();
    if(header&&'ResizeObserver'in window){observer=new ResizeObserver(update);observer.observe(header);}
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
  window.addEventListener('pagehide',()=>observer?.disconnect(),{once:true});
})();
